import React, { FC, ReactNode } from 'react'

import "./AvatarsRow.scss"

const AvatarsRow: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="AvatarsRow">
    {children}
  </div>
)

export default AvatarsRow
